{
    "1.8": {
        "blocks": [
            [
                "wood_planks",
                "planks"
            ],
            [
                "large_flowers",
                "double_plant"
            ]
        ]
    },
    "1.12": {
        "items": [
            [
                "totem",
                "totem_of_undying"
            ]
        ]
    },
    "1.13": {
        "blocks": [
            [
                "stone",
                "granite"
            ],
            [
                "stone",
                "polished_granite"
            ],
            [
                "stone",
                "diorite"
            ],
            [
                "stone",
                "polished_diorite"
            ],
            [
                "stone",
                "andesite"
            ],
            [
                "stone",
                "polished_andesite"
            ],
            [
                "grass",
                "grass_block"
            ],
            [
                "dirt",
                "coarse_dirt"
            ],
            [
                "dirt",
                "podzol"
            ],
            [
                "planks",
                "oak_planks"
            ],
            [
                "planks",
                "spruce_planks"
            ],
            [
                "planks",
                "birch_planks"
            ],
            [
                "planks",
                "jungle_planks"
            ],
            [
                "planks",
                "acacia_planks"
            ],
            [
                "planks",
                "dark_oak_planks"
            ],
            [
                "sapling",
                "oak_sapling"
            ],
            [
                "sapling",
                "spruce_sapling"
            ],
            [
                "sapling",
                "birch_sapling"
            ],
            [
                "sapling",
                "jungle_sapling"
            ],
            [
                "sapling",
                "acacia_sapling"
            ],
            [
                "sapling",
                "dark_oak_sapling"
            ],
            [
                "sand",
                "red_sand"
            ],
            [
                "log",
                "oak_log"
            ],
            [
                "log",
                "spruce_log"
            ],
            [
                "log",
                "birch_log"
            ],
            [
                "log",
                "jungle_log"
            ],
            [
                "log",
                "oak_wood"
            ],
            [
                "log",
                "spruce_wood"
            ],
            [
                "log",
                "birch_wood"
            ],
            [
                "log",
                "jungle_wood"
            ],
            [
                "leaves",
                "oak_leaves"
            ],
            [
                "leaves",
                "spruce_leaves"
            ],
            [
                "leaves",
                "birch_leaves"
            ],
            [
                "leaves",
                "jungle_leaves"
            ],
            [
                "sponge",
                "wet_sponge"
            ],
            [
                "sandstone",
                "chiseled_sandstone"
            ],
            [
                "sandstone",
                "cut_sandstone"
            ],
            [
                "noteblock",
                "note_block"
            ],
            [
                "bed",
                "red_bed"
            ],
            [
                "golden_rail",
                "powered_rail"
            ],
            [
                "web",
                "cobweb"
            ],
            [
                "tallgrass",
                "dead_bush"
            ],
            [
                "tallgrass",
                "grass"
            ],
            [
                "tallgrass",
                "fern"
            ],
            [
                "deadbush",
                "dead_bush"
            ],
            [
                "wool",
                "white_wool"
            ],
            [
                "wool",
                "orange_wool"
            ],
            [
                "wool",
                "magenta_wool"
            ],
            [
                "wool",
                "light_blue_wool"
            ],
            [
                "wool",
                "yellow_wool"
            ],
            [
                "wool",
                "lime_wool"
            ],
            [
                "wool",
                "pink_wool"
            ],
            [
                "wool",
                "gray_wool"
            ],
            [
                "wool",
                "light_gray_wool"
            ],
            [
                "wool",
                "cyan_wool"
            ],
            [
                "wool",
                "purple_wool"
            ],
            [
                "wool",
                "blue_wool"
            ],
            [
                "wool",
                "brown_wool"
            ],
            [
                "wool",
                "green_wool"
            ],
            [
                "wool",
                "red_wool"
            ],
            [
                "wool",
                "black_wool"
            ],
            [
                "piston_extension",
                "moving_piston"
            ],
            [
                "yellow_flower",
                "dandelion"
            ],
            [
                "red_flower",
                "poppy"
            ],
            [
                "red_flower",
                "blue_orchid"
            ],
            [
                "red_flower",
                "allium"
            ],
            [
                "red_flower",
                "azure_bluet"
            ],
            [
                "red_flower",
                "red_tulip"
            ],
            [
                "red_flower",
                "orange_tulip"
            ],
            [
                "red_flower",
                "white_tulip"
            ],
            [
                "red_flower",
                "pink_tulip"
            ],
            [
                "red_flower",
                "oxeye_daisy"
            ],
            [
                "double_stone_slab",
                "stone_slab"
            ],
            [
                "double_stone_slab",
                "sandstone_slab"
            ],
            [
                "double_stone_slab",
                "petrified_oak_slab"
            ],
            [
                "double_stone_slab",
                "cobblestone_slab"
            ],
            [
                "double_stone_slab",
                "brick_slab"
            ],
            [
                "double_stone_slab",
                "stone_brick_slab"
            ],
            [
                "double_stone_slab",
                "nether_brick_slab"
            ],
            [
                "double_stone_slab",
                "quartz_slab"
            ],
            [
                "double_stone_slab",
                "smooth_stone"
            ],
            [
                "double_stone_slab",
                "smooth_sandstone"
            ],
            [
                "double_stone_slab",
                "smooth_quartz"
            ],
            [
                "stone_slab",
                "sandstone_slab"
            ],
            [
                "stone_slab",
                "petrified_oak_slab"
            ],
            [
                "stone_slab",
                "cobblestone_slab"
            ],
            [
                "stone_slab",
                "brick_slab"
            ],
            [
                "stone_slab",
                "stone_brick_slab"
            ],
            [
                "stone_slab",
                "nether_brick_slab"
            ],
            [
                "stone_slab",
                "quartz_slab"
            ],
            [
                "brick_block",
                "bricks"
            ],
            [
                "torch",
                "wall_torch"
            ],
            [
                "mob_spawner",
                "spawner"
            ],
            [
                "lit_furnace",
                "furnace"
            ],
            [
                "standing_sign",
                "sign"
            ],
            [
                "wooden_door",
                "oak_door"
            ],
            [
                "stone_stairs",
                "cobblestone_stairs"
            ],
            [
                "wooden_pressure_plate",
                "oak_pressure_plate"
            ],
            [
                "lit_redstone_ore",
                "redstone_ore"
            ],
            [
                "unlit_redstone_torch",
                "redstone_wall_torch"
            ],
            [
                "unlit_redstone_torch",
                "redstone_torch"
            ],
            [
                "redstone_torch",
                "redstone_wall_torch"
            ],
            [
                "snow_layer",
                "snow"
            ],
            [
                "snow",
                "snow_block"
            ],
            [
                "reeds",
                "sugar_cane"
            ],
            [
                "fence",
                "oak_fence"
            ],
            [
                "pumpkin",
                "carved_pumpkin"
            ],
            [
                "portal",
                "nether_portal"
            ],
            [
                "lit_pumpkin",
                "jack_o_lantern"
            ],
            [
                "unpowered_repeater",
                "repeater"
            ],
            [
                "powered_repeater",
                "repeater"
            ],
            [
                "stained_glass",
                "white_stained_glass"
            ],
            [
                "stained_glass",
                "orange_stained_glass"
            ],
            [
                "stained_glass",
                "magenta_stained_glass"
            ],
            [
                "stained_glass",
                "light_blue_stained_glass"
            ],
            [
                "stained_glass",
                "yellow_stained_glass"
            ],
            [
                "stained_glass",
                "lime_stained_glass"
            ],
            [
                "stained_glass",
                "pink_stained_glass"
            ],
            [
                "stained_glass",
                "gray_stained_glass"
            ],
            [
                "stained_glass",
                "light_gray_stained_glass"
            ],
            [
                "stained_glass",
                "cyan_stained_glass"
            ],
            [
                "stained_glass",
                "purple_stained_glass"
            ],
            [
                "stained_glass",
                "blue_stained_glass"
            ],
            [
                "stained_glass",
                "brown_stained_glass"
            ],
            [
                "stained_glass",
                "green_stained_glass"
            ],
            [
                "stained_glass",
                "red_stained_glass"
            ],
            [
                "stained_glass",
                "black_stained_glass"
            ],
            [
                "trapdoor",
                "oak_trapdoor"
            ],
            [
                "monster_egg",
                "infested_stone"
            ],
            [
                "monster_egg",
                "infested_cobblestone"
            ],
            [
                "monster_egg",
                "infested_stone_bricks"
            ],
            [
                "monster_egg",
                "infested_mossy_stone_bricks"
            ],
            [
                "monster_egg",
                "infested_cracked_stone_bricks"
            ],
            [
                "monster_egg",
                "infested_chiseled_stone_bricks"
            ],
            [
                "stonebrick",
                "stone_bricks"
            ],
            [
                "stonebrick",
                "mossy_stone_bricks"
            ],
            [
                "stonebrick",
                "cracked_stone_bricks"
            ],
            [
                "stonebrick",
                "chiseled_stone_bricks"
            ],
            [
                "brown_mushroom_block",
                "mushroom_stem"
            ],
            [
                "red_mushroom_block",
                "mushroom_stem"
            ],
            [
                "melon_block",
                "melon"
            ],
            [
                "fence_gate",
                "oak_fence_gate"
            ],
            [
                "waterlily",
                "lily_pad"
            ],
            [
                "nether_brick",
                "nether_bricks"
            ],
            [
                "lit_redstone_lamp",
                "redstone_lamp"
            ],
            [
                "double_wooden_slab",
                "oak_slab"
            ],
            [
                "double_wooden_slab",
                "spruce_slab"
            ],
            [
                "double_wooden_slab",
                "birch_slab"
            ],
            [
                "double_wooden_slab",
                "jungle_slab"
            ],
            [
                "double_wooden_slab",
                "acacia_slab"
            ],
            [
                "double_wooden_slab",
                "dark_oak_slab"
            ],
            [
                "wooden_slab",
                "oak_slab"
            ],
            [
                "wooden_slab",
                "spruce_slab"
            ],
            [
                "wooden_slab",
                "birch_slab"
            ],
            [
                "wooden_slab",
                "jungle_slab"
            ],
            [
                "wooden_slab",
                "acacia_slab"
            ],
            [
                "wooden_slab",
                "dark_oak_slab"
            ],
            [
                "cobblestone_wall",
                "mossy_cobblestone_wall"
            ],
            [
                "flower_pot",
                "potted_poppy"
            ],
            [
                "flower_pot",
                "potted_dandelion"
            ],
            [
                "flower_pot",
                "potted_oak_sapling"
            ],
            [
                "flower_pot",
                "potted_spruce_sapling"
            ],
            [
                "flower_pot",
                "potted_birch_sapling"
            ],
            [
                "flower_pot",
                "potted_jungle_sapling"
            ],
            [
                "flower_pot",
                "potted_red_mushroom"
            ],
            [
                "flower_pot",
                "potted_brown_mushroom"
            ],
            [
                "flower_pot",
                "potted_cactus"
            ],
            [
                "flower_pot",
                "potted_dead_bush"
            ],
            [
                "flower_pot",
                "potted_fern"
            ],
            [
                "flower_pot",
                "potted_acacia_sapling"
            ],
            [
                "flower_pot",
                "potted_dark_oak_sapling"
            ],
            [
                "flower_pot",
                "potted_blue_orchid"
            ],
            [
                "flower_pot",
                "potted_allium"
            ],
            [
                "wooden_button",
                "oak_button"
            ],
            [
                "skull",
                "skeleton_skull"
            ],
            [
                "skull",
                "skeleton_wall_skull"
            ],
            [
                "anvil",
                "chipped_anvil"
            ],
            [
                "anvil",
                "damaged_anvil"
            ],
            [
                "unpowered_comparator",
                "comparator"
            ],
            [
                "powered_comparator",
                "comparator"
            ],
            [
                "quartz_ore",
                "nether_quartz_ore"
            ],
            [
                "quartz_block",
                "chiseled_quartz_block"
            ],
            [
                "quartz_block",
                "quartz_pillar"
            ],
            [
                "stained_hardened_clay",
                "white_terracotta"
            ],
            [
                "stained_hardened_clay",
                "orange_terracotta"
            ],
            [
                "stained_hardened_clay",
                "magenta_terracotta"
            ],
            [
                "stained_hardened_clay",
                "light_blue_terracotta"
            ],
            [
                "stained_hardened_clay",
                "yellow_terracotta"
            ],
            [
                "stained_hardened_clay",
                "lime_terracotta"
            ],
            [
                "stained_hardened_clay",
                "pink_terracotta"
            ],
            [
                "stained_hardened_clay",
                "gray_terracotta"
            ],
            [
                "stained_hardened_clay",
                "light_gray_terracotta"
            ],
            [
                "stained_hardened_clay",
                "cyan_terracotta"
            ],
            [
                "stained_hardened_clay",
                "purple_terracotta"
            ],
            [
                "stained_hardened_clay",
                "blue_terracotta"
            ],
            [
                "stained_hardened_clay",
                "brown_terracotta"
            ],
            [
                "stained_hardened_clay",
                "green_terracotta"
            ],
            [
                "stained_hardened_clay",
                "red_terracotta"
            ],
            [
                "stained_hardened_clay",
                "black_terracotta"
            ],
            [
                "stained_glass_pane",
                "white_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "orange_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "magenta_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "light_blue_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "yellow_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "lime_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "pink_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "gray_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "light_gray_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "cyan_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "purple_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "blue_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "brown_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "green_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "red_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "black_stained_glass_pane"
            ],
            [
                "leaves2",
                "acacia_leaves"
            ],
            [
                "leaves2",
                "dark_oak_leaves"
            ],
            [
                "log2",
                "acacia_log"
            ],
            [
                "log2",
                "dark_oak_log"
            ],
            [
                "log2",
                "acacia_wood"
            ],
            [
                "log2",
                "dark_oak_wood"
            ],
            [
                "slime",
                "slime_block"
            ],
            [
                "prismarine",
                "prismarine_bricks"
            ],
            [
                "prismarine",
                "dark_prismarine"
            ],
            [
                "carpet",
                "white_carpet"
            ],
            [
                "carpet",
                "orange_carpet"
            ],
            [
                "carpet",
                "magenta_carpet"
            ],
            [
                "carpet",
                "light_blue_carpet"
            ],
            [
                "carpet",
                "yellow_carpet"
            ],
            [
                "carpet",
                "lime_carpet"
            ],
            [
                "carpet",
                "pink_carpet"
            ],
            [
                "carpet",
                "gray_carpet"
            ],
            [
                "carpet",
                "light_gray_carpet"
            ],
            [
                "carpet",
                "cyan_carpet"
            ],
            [
                "carpet",
                "purple_carpet"
            ],
            [
                "carpet",
                "blue_carpet"
            ],
            [
                "carpet",
                "brown_carpet"
            ],
            [
                "carpet",
                "green_carpet"
            ],
            [
                "carpet",
                "red_carpet"
            ],
            [
                "carpet",
                "black_carpet"
            ],
            [
                "hardened_clay",
                "terracotta"
            ],
            [
                "double_plant",
                "sunflower"
            ],
            [
                "double_plant",
                "lilac"
            ],
            [
                "double_plant",
                "tall_grass"
            ],
            [
                "double_plant",
                "large_fern"
            ],
            [
                "double_plant",
                "rose_bush"
            ],
            [
                "double_plant",
                "peony"
            ],
            [
                "standing_banner",
                "white_banner"
            ],
            [
                "wall_banner",
                "white_wall_banner"
            ],
            [
                "daylight_detector_inverted",
                "daylight_detector"
            ],
            [
                "red_sandstone",
                "chiseled_red_sandstone"
            ],
            [
                "red_sandstone",
                "cut_red_sandstone"
            ],
            [
                "double_stone_slab2",
                "red_sandstone_slab"
            ],
            [
                "double_stone_slab2",
                "smooth_red_sandstone"
            ],
            [
                "stone_slab2",
                "red_sandstone_slab"
            ],
            [
                "purpur_double_slab",
                "purpur_slab"
            ],
            [
                "end_bricks",
                "end_stone_bricks"
            ],
            [
                "magma",
                "magma_block"
            ],
            [
                "red_nether_brick",
                "red_nether_bricks"
            ],
            [
                "concrete",
                "white_concrete"
            ],
            [
                "concrete",
                "orange_concrete"
            ],
            [
                "concrete",
                "magenta_concrete"
            ],
            [
                "concrete",
                "light_blue_concrete"
            ],
            [
                "concrete",
                "yellow_concrete"
            ],
            [
                "concrete",
                "lime_concrete"
            ],
            [
                "concrete",
                "pink_concrete"
            ],
            [
                "concrete",
                "gray_concrete"
            ],
            [
                "concrete",
                "light_gray_concrete"
            ],
            [
                "concrete",
                "cyan_concrete"
            ],
            [
                "concrete",
                "purple_concrete"
            ],
            [
                "concrete",
                "blue_concrete"
            ],
            [
                "concrete",
                "brown_concrete"
            ],
            [
                "concrete",
                "green_concrete"
            ],
            [
                "concrete",
                "red_concrete"
            ],
            [
                "concrete",
                "black_concrete"
            ],
            [
                "concrete_powder",
                "white_concrete_powder"
            ],
            [
                "concrete_powder",
                "orange_concrete_powder"
            ],
            [
                "concrete_powder",
                "magenta_concrete_powder"
            ],
            [
                "concrete_powder",
                "light_blue_concrete_powder"
            ],
            [
                "concrete_powder",
                "yellow_concrete_powder"
            ],
            [
                "concrete_powder",
                "lime_concrete_powder"
            ],
            [
                "concrete_powder",
                "pink_concrete_powder"
            ],
            [
                "concrete_powder",
                "gray_concrete_powder"
            ],
            [
                "concrete_powder",
                "light_gray_concrete_powder"
            ],
            [
                "concrete_powder",
                "cyan_concrete_powder"
            ],
            [
                "concrete_powder",
                "purple_concrete_powder"
            ],
            [
                "concrete_powder",
                "blue_concrete_powder"
            ],
            [
                "concrete_powder",
                "brown_concrete_powder"
            ],
            [
                "concrete_powder",
                "green_concrete_powder"
            ],
            [
                "concrete_powder",
                "red_concrete_powder"
            ],
            [
                "concrete_powder",
                "black_concrete_powder"
            ]
        ],
        "items": [
            [
                "stone",
                "granite"
            ],
            [
                "stone",
                "polished_granite"
            ],
            [
                "stone",
                "diorite"
            ],
            [
                "stone",
                "polished_diorite"
            ],
            [
                "stone",
                "andesite"
            ],
            [
                "stone",
                "polished_andesite"
            ],
            [
                "grass",
                "grass_block"
            ],
            [
                "dirt",
                "coarse_dirt"
            ],
            [
                "dirt",
                "podzol"
            ],
            [
                "planks",
                "oak_planks"
            ],
            [
                "planks",
                "spruce_planks"
            ],
            [
                "planks",
                "birch_planks"
            ],
            [
                "planks",
                "jungle_planks"
            ],
            [
                "planks",
                "acacia_planks"
            ],
            [
                "planks",
                "dark_oak_planks"
            ],
            [
                "sapling",
                "oak_sapling"
            ],
            [
                "sapling",
                "spruce_sapling"
            ],
            [
                "sapling",
                "birch_sapling"
            ],
            [
                "sapling",
                "jungle_sapling"
            ],
            [
                "sapling",
                "acacia_sapling"
            ],
            [
                "sapling",
                "dark_oak_sapling"
            ],
            [
                "sand",
                "red_sand"
            ],
            [
                "log",
                "oak_log"
            ],
            [
                "log",
                "spruce_log"
            ],
            [
                "log",
                "birch_log"
            ],
            [
                "log",
                "jungle_log"
            ],
            [
                "leaves",
                "oak_leaves"
            ],
            [
                "leaves",
                "spruce_leaves"
            ],
            [
                "leaves",
                "birch_leaves"
            ],
            [
                "leaves",
                "jungle_leaves"
            ],
            [
                "sponge",
                "wet_sponge"
            ],
            [
                "sandstone",
                "chiseled_sandstone"
            ],
            [
                "sandstone",
                "cut_sandstone"
            ],
            [
                "noteblock",
                "note_block"
            ],
            [
                "golden_rail",
                "powered_rail"
            ],
            [
                "web",
                "cobweb"
            ],
            [
                "tallgrass",
                "grass"
            ],
            [
                "tallgrass",
                "fern"
            ],
            [
                "deadbush",
                "dead_bush"
            ],
            [
                "wool",
                "white_wool"
            ],
            [
                "wool",
                "orange_wool"
            ],
            [
                "wool",
                "magenta_wool"
            ],
            [
                "wool",
                "light_blue_wool"
            ],
            [
                "wool",
                "yellow_wool"
            ],
            [
                "wool",
                "lime_wool"
            ],
            [
                "wool",
                "pink_wool"
            ],
            [
                "wool",
                "gray_wool"
            ],
            [
                "wool",
                "light_gray_wool"
            ],
            [
                "wool",
                "cyan_wool"
            ],
            [
                "wool",
                "purple_wool"
            ],
            [
                "wool",
                "blue_wool"
            ],
            [
                "wool",
                "brown_wool"
            ],
            [
                "wool",
                "green_wool"
            ],
            [
                "wool",
                "red_wool"
            ],
            [
                "wool",
                "black_wool"
            ],
            [
                "yellow_flower",
                "dandelion"
            ],
            [
                "red_flower",
                "poppy"
            ],
            [
                "red_flower",
                "blue_orchid"
            ],
            [
                "red_flower",
                "allium"
            ],
            [
                "red_flower",
                "azure_bluet"
            ],
            [
                "red_flower",
                "red_tulip"
            ],
            [
                "red_flower",
                "orange_tulip"
            ],
            [
                "red_flower",
                "white_tulip"
            ],
            [
                "red_flower",
                "pink_tulip"
            ],
            [
                "red_flower",
                "oxeye_daisy"
            ],
            [
                "stone_slab",
                "sandstone_slab"
            ],
            [
                "stone_slab",
                "cobblestone_slab"
            ],
            [
                "stone_slab",
                "brick_slab"
            ],
            [
                "stone_slab",
                "stone_brick_slab"
            ],
            [
                "stone_slab",
                "nether_brick_slab"
            ],
            [
                "stone_slab",
                "quartz_slab"
            ],
            [
                "brick_block",
                "bricks"
            ],
            [
                "mob_spawner",
                "spawner"
            ],
            [
                "stone_stairs",
                "cobblestone_stairs"
            ],
            [
                "wooden_pressure_plate",
                "oak_pressure_plate"
            ],
            [
                "snow_layer",
                "snow"
            ],
            [
                "snow",
                "snow_block"
            ],
            [
                "fence",
                "oak_fence"
            ],
            [
                "pumpkin",
                "carved_pumpkin"
            ],
            [
                "lit_pumpkin",
                "jack_o_lantern"
            ],
            [
                "stained_glass",
                "white_stained_glass"
            ],
            [
                "stained_glass",
                "orange_stained_glass"
            ],
            [
                "stained_glass",
                "magenta_stained_glass"
            ],
            [
                "stained_glass",
                "light_blue_stained_glass"
            ],
            [
                "stained_glass",
                "yellow_stained_glass"
            ],
            [
                "stained_glass",
                "lime_stained_glass"
            ],
            [
                "stained_glass",
                "pink_stained_glass"
            ],
            [
                "stained_glass",
                "gray_stained_glass"
            ],
            [
                "stained_glass",
                "light_gray_stained_glass"
            ],
            [
                "stained_glass",
                "cyan_stained_glass"
            ],
            [
                "stained_glass",
                "purple_stained_glass"
            ],
            [
                "stained_glass",
                "blue_stained_glass"
            ],
            [
                "stained_glass",
                "brown_stained_glass"
            ],
            [
                "stained_glass",
                "green_stained_glass"
            ],
            [
                "stained_glass",
                "red_stained_glass"
            ],
            [
                "stained_glass",
                "black_stained_glass"
            ],
            [
                "trapdoor",
                "oak_trapdoor"
            ],
            [
                "monster_egg",
                "infested_stone"
            ],
            [
                "monster_egg",
                "infested_cobblestone"
            ],
            [
                "monster_egg",
                "infested_stone_bricks"
            ],
            [
                "monster_egg",
                "infested_mossy_stone_bricks"
            ],
            [
                "monster_egg",
                "infested_cracked_stone_bricks"
            ],
            [
                "monster_egg",
                "infested_chiseled_stone_bricks"
            ],
            [
                "stonebrick",
                "stone_bricks"
            ],
            [
                "stonebrick",
                "mossy_stone_bricks"
            ],
            [
                "stonebrick",
                "cracked_stone_bricks"
            ],
            [
                "stonebrick",
                "chiseled_stone_bricks"
            ],
            [
                "melon_block",
                "melon"
            ],
            [
                "fence_gate",
                "oak_fence_gate"
            ],
            [
                "waterlily",
                "lily_pad"
            ],
            [
                "nether_brick",
                "nether_bricks"
            ],
            [
                "wooden_slab",
                "oak_slab"
            ],
            [
                "wooden_slab",
                "spruce_slab"
            ],
            [
                "wooden_slab",
                "birch_slab"
            ],
            [
                "wooden_slab",
                "jungle_slab"
            ],
            [
                "wooden_slab",
                "acacia_slab"
            ],
            [
                "wooden_slab",
                "dark_oak_slab"
            ],
            [
                "cobblestone_wall",
                "mossy_cobblestone_wall"
            ],
            [
                "wooden_button",
                "oak_button"
            ],
            [
                "anvil",
                "chipped_anvil"
            ],
            [
                "anvil",
                "damaged_anvil"
            ],
            [
                "quartz_ore",
                "nether_quartz_ore"
            ],
            [
                "quartz_block",
                "chiseled_quartz_block"
            ],
            [
                "quartz_block",
                "quartz_pillar"
            ],
            [
                "stained_hardened_clay",
                "white_terracotta"
            ],
            [
                "stained_hardened_clay",
                "orange_terracotta"
            ],
            [
                "stained_hardened_clay",
                "magenta_terracotta"
            ],
            [
                "stained_hardened_clay",
                "light_blue_terracotta"
            ],
            [
                "stained_hardened_clay",
                "yellow_terracotta"
            ],
            [
                "stained_hardened_clay",
                "lime_terracotta"
            ],
            [
                "stained_hardened_clay",
                "pink_terracotta"
            ],
            [
                "stained_hardened_clay",
                "gray_terracotta"
            ],
            [
                "stained_hardened_clay",
                "light_gray_terracotta"
            ],
            [
                "stained_hardened_clay",
                "cyan_terracotta"
            ],
            [
                "stained_hardened_clay",
                "purple_terracotta"
            ],
            [
                "stained_hardened_clay",
                "blue_terracotta"
            ],
            [
                "stained_hardened_clay",
                "brown_terracotta"
            ],
            [
                "stained_hardened_clay",
                "green_terracotta"
            ],
            [
                "stained_hardened_clay",
                "red_terracotta"
            ],
            [
                "stained_hardened_clay",
                "black_terracotta"
            ],
            [
                "stained_glass_pane",
                "white_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "orange_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "magenta_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "light_blue_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "yellow_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "lime_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "pink_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "gray_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "light_gray_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "cyan_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "purple_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "blue_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "brown_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "green_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "red_stained_glass_pane"
            ],
            [
                "stained_glass_pane",
                "black_stained_glass_pane"
            ],
            [
                "leaves2",
                "acacia_leaves"
            ],
            [
                "leaves2",
                "dark_oak_leaves"
            ],
            [
                "log2",
                "acacia_log"
            ],
            [
                "log2",
                "dark_oak_log"
            ],
            [
                "slime",
                "slime_block"
            ],
            [
                "prismarine",
                "prismarine_bricks"
            ],
            [
                "prismarine",
                "dark_prismarine"
            ],
            [
                "carpet",
                "white_carpet"
            ],
            [
                "carpet",
                "orange_carpet"
            ],
            [
                "carpet",
                "magenta_carpet"
            ],
            [
                "carpet",
                "light_blue_carpet"
            ],
            [
                "carpet",
                "yellow_carpet"
            ],
            [
                "carpet",
                "lime_carpet"
            ],
            [
                "carpet",
                "pink_carpet"
            ],
            [
                "carpet",
                "gray_carpet"
            ],
            [
                "carpet",
                "light_gray_carpet"
            ],
            [
                "carpet",
                "cyan_carpet"
            ],
            [
                "carpet",
                "purple_carpet"
            ],
            [
                "carpet",
                "blue_carpet"
            ],
            [
                "carpet",
                "brown_carpet"
            ],
            [
                "carpet",
                "green_carpet"
            ],
            [
                "carpet",
                "red_carpet"
            ],
            [
                "carpet",
                "black_carpet"
            ],
            [
                "hardened_clay",
                "terracotta"
            ],
            [
                "double_plant",
                "sunflower"
            ],
            [
                "double_plant",
                "lilac"
            ],
            [
                "double_plant",
                "tall_grass"
            ],
            [
                "double_plant",
                "large_fern"
            ],
            [
                "double_plant",
                "rose_bush"
            ],
            [
                "double_plant",
                "peony"
            ],
            [
                "red_sandstone",
                "chiseled_red_sandstone"
            ],
            [
                "red_sandstone",
                "cut_red_sandstone"
            ],
            [
                "stone_slab2",
                "red_sandstone_slab"
            ],
            [
                "end_bricks",
                "end_stone_bricks"
            ],
            [
                "magma",
                "magma_block"
            ],
            [
                "red_nether_brick",
                "red_nether_bricks"
            ],
            [
                "silver_shulker_box",
                "light_gray_shulker_box"
            ],
            [
                "silver_glazed_terracotta",
                "light_gray_glazed_terracotta"
            ],
            [
                "concrete",
                "white_concrete"
            ],
            [
                "concrete",
                "orange_concrete"
            ],
            [
                "concrete",
                "magenta_concrete"
            ],
            [
                "concrete",
                "light_blue_concrete"
            ],
            [
                "concrete",
                "yellow_concrete"
            ],
            [
                "concrete",
                "lime_concrete"
            ],
            [
                "concrete",
                "pink_concrete"
            ],
            [
                "concrete",
                "gray_concrete"
            ],
            [
                "concrete",
                "light_gray_concrete"
            ],
            [
                "concrete",
                "cyan_concrete"
            ],
            [
                "concrete",
                "purple_concrete"
            ],
            [
                "concrete",
                "blue_concrete"
            ],
            [
                "concrete",
                "brown_concrete"
            ],
            [
                "concrete",
                "green_concrete"
            ],
            [
                "concrete",
                "red_concrete"
            ],
            [
                "concrete",
                "black_concrete"
            ],
            [
                "concrete_powder",
                "white_concrete_powder"
            ],
            [
                "concrete_powder",
                "orange_concrete_powder"
            ],
            [
                "concrete_powder",
                "magenta_concrete_powder"
            ],
            [
                "concrete_powder",
                "light_blue_concrete_powder"
            ],
            [
                "concrete_powder",
                "yellow_concrete_powder"
            ],
            [
                "concrete_powder",
                "lime_concrete_powder"
            ],
            [
                "concrete_powder",
                "pink_concrete_powder"
            ],
            [
                "concrete_powder",
                "gray_concrete_powder"
            ],
            [
                "concrete_powder",
                "light_gray_concrete_powder"
            ],
            [
                "concrete_powder",
                "cyan_concrete_powder"
            ],
            [
                "concrete_powder",
                "purple_concrete_powder"
            ],
            [
                "concrete_powder",
                "blue_concrete_powder"
            ],
            [
                "concrete_powder",
                "brown_concrete_powder"
            ],
            [
                "concrete_powder",
                "green_concrete_powder"
            ],
            [
                "concrete_powder",
                "red_concrete_powder"
            ],
            [
                "concrete_powder",
                "black_concrete_powder"
            ],
            [
                "coal",
                "charcoal"
            ],
            [
                "golden_apple",
                "enchanted_golden_apple"
            ],
            [
                "wooden_door",
                "oak_door"
            ],
            [
                "boat",
                "oak_boat"
            ],
            [
                "reeds",
                "sugar_cane"
            ],
            [
                "fish",
                "cod"
            ],
            [
                "fish",
                "salmon"
            ],
            [
                "fish",
                "tropical_fish"
            ],
            [
                "fish",
                "pufferfish"
            ],
            [
                "cooked_fish",
                "cooked_cod"
            ],
            [
                "cooked_fish",
                "cooked_salmon"
            ],
            [
                "dye",
                "ink_sac"
            ],
            [
                "dye",
                "rose_red"
            ],
            [
                "dye",
                "cactus_green"
            ],
            [
                "dye",
                "cocoa_beans"
            ],
            [
                "dye",
                "lapis_lazuli"
            ],
            [
                "dye",
                "purple_dye"
            ],
            [
                "dye",
                "cyan_dye"
            ],
            [
                "dye",
                "light_gray_dye"
            ],
            [
                "dye",
                "gray_dye"
            ],
            [
                "dye",
                "pink_dye"
            ],
            [
                "dye",
                "lime_dye"
            ],
            [
                "dye",
                "dandelion_yellow"
            ],
            [
                "dye",
                "light_blue_dye"
            ],
            [
                "dye",
                "magenta_dye"
            ],
            [
                "dye",
                "orange_dye"
            ],
            [
                "dye",
                "bone_meal"
            ],
            [
                "bed",
                "white_bed"
            ],
            [
                "bed",
                "orange_bed"
            ],
            [
                "bed",
                "magenta_bed"
            ],
            [
                "bed",
                "light_blue_bed"
            ],
            [
                "bed",
                "yellow_bed"
            ],
            [
                "bed",
                "lime_bed"
            ],
            [
                "bed",
                "pink_bed"
            ],
            [
                "bed",
                "gray_bed"
            ],
            [
                "bed",
                "light_gray_bed"
            ],
            [
                "bed",
                "cyan_bed"
            ],
            [
                "bed",
                "purple_bed"
            ],
            [
                "bed",
                "blue_bed"
            ],
            [
                "bed",
                "brown_bed"
            ],
            [
                "bed",
                "green_bed"
            ],
            [
                "bed",
                "red_bed"
            ],
            [
                "bed",
                "black_bed"
            ],
            [
                "melon",
                "melon_slice"
            ],
            [
                "speckled_melon",
                "glistering_melon_slice"
            ],
            [
                "spawn_egg",
                "pig_spawn_egg"
            ],
            [
                "skull",
                "skeleton_skull"
            ],
            [
                "skull",
                "wither_skeleton_skull"
            ],
            [
                "skull",
                "zombie_head"
            ],
            [
                "skull",
                "player_head"
            ],
            [
                "skull",
                "creeper_head"
            ],
            [
                "skull",
                "dragon_head"
            ],
            [
                "fireworks",
                "firework_rocket"
            ],
            [
                "firework_charge",
                "firework_star"
            ],
            [
                "netherbrick",
                "nether_brick"
            ],
            [
                "banner",
                "black_banner"
            ],
            [
                "banner",
                "red_banner"
            ],
            [
                "banner",
                "green_banner"
            ],
            [
                "banner",
                "brown_banner"
            ],
            [
                "banner",
                "blue_banner"
            ],
            [
                "banner",
                "purple_banner"
            ],
            [
                "banner",
                "cyan_banner"
            ],
            [
                "banner",
                "light_gray_banner"
            ],
            [
                "banner",
                "gray_banner"
            ],
            [
                "banner",
                "pink_banner"
            ],
            [
                "banner",
                "lime_banner"
            ],
            [
                "banner",
                "yellow_banner"
            ],
            [
                "banner",
                "light_blue_banner"
            ],
            [
                "banner",
                "magenta_banner"
            ],
            [
                "banner",
                "orange_banner"
            ],
            [
                "banner",
                "white_banner"
            ],
            [
                "chorus_fruit_popped",
                "popped_chorus_fruit"
            ],
            [
                "record_13",
                "music_disc_13"
            ],
            [
                "record_cat",
                "music_disc_cat"
            ],
            [
                "record_blocks",
                "music_disc_blocks"
            ],
            [
                "record_chirp",
                "music_disc_chirp"
            ],
            [
                "record_far",
                "music_disc_far"
            ],
            [
                "record_mall",
                "music_disc_mall"
            ],
            [
                "record_mellohi",
                "music_disc_mellohi"
            ],
            [
                "record_stal",
                "music_disc_stal"
            ],
            [
                "record_strad",
                "music_disc_strad"
            ],
            [
                "record_ward",
                "music_disc_ward"
            ],
            [
                "record_11",
                "music_disc_11"
            ],
            [
                "record_wait",
                "music_disc_wait"
            ]
        ]
    },
    "1.14": {
        "blocks": [
            [
                "sign",
                "oak_sign"
            ],
            [
                "wall_sign",
                "oak_wall_sign"
            ]
        ],
        "items": [
            [
                "sign",
                "oak_sign"
            ],
            [
                "rose_red",
                "red_dye"
            ],
            [
                "cactus_green",
                "green_dye"
            ],
            [
                "dandelion_yellow",
                "yellow_dye"
            ]
        ]
    },
    "1.15.2": {
        "blocks": [],
        "items": []
    },
    "1.16.1": {
        "blocks": [],
        "items": [
            [
                "zombie_pigman_spawn_egg",
                "zombified_piglin_spawn_egg"
            ]
        ]
    },
    "1.16.2": {
        "blocks": [],
        "items": []
    },
    "1.17": {
        "blocks": [
            [
                "grass_path",
                "dirt_path"
            ]
        ],
        "items": [
            [
                "grass_path",
                "dirt_path"
            ]
        ]
    },
    "1.18": {
        "blocks": [],
        "items": []
    },
    "1.19": {
        "blocks": [],
        "items": []
    },
    "1.19.3": {
        "blocks": [],
        "items": []
    },
    "1.19.4": {
        "blocks": [],
        "items": []
    },
    "1.20": {
        "blocks": [],
        "items": [
            [
                "pottery_shard_archer",
                "archer_pottery_sherd"
            ],
            [
                "pottery_shard_prize",
                "prize_pottery_sherd"
            ],
            [
                "pottery_shard_arms_up",
                "arms_up_pottery_sherd"
            ],
            [
                "pottery_shard_skull",
                "skull_pottery_sherd"
            ]
        ]
    },
    "1.16": {
        "items": [
            [
                "zombie_pigman_spawn_egg",
                "zombified_piglin_spawn_egg"
            ]
        ]
    },
    "1.20.3": {
        "blocks": [
            [
                "grass",
                "short_grass"
            ]
        ],
        "items": [
            [
                "grass",
                "short_grass"
            ]
        ]
    }
}
